import { Box, Container, Paper, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2'; // Grid version 2
import { AnalyticsPageType } from '@shopify/hydrogen-react';
import { navigate } from 'gatsby';
import { GatsbyImage, getImage, getSrc, IGatsbyImageData } from 'gatsby-plugin-image';
import React, { useEffect, useMemo, useState } from 'react';

import { HorizontalSlantContainer } from '../../../components/horizontal-slant-container';
import { VariantSelector } from '../../../components/products/card';
import { headerSlantContainerNoContent } from '../../../shared/styles/headerSlantContainer';
// import { antiSlugify } from '../../../shared/utils';


import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { AddToCart } from '../../../components/cart/addToCart/button';
import { AddToCartMulti } from '../../../components/cart/addToCart/multi';
import { MoneyDisplay } from '../../../components/cart/moneyDisplay';
import { PurchaseCounter } from '../../../components/cart/purchase-counter';
import { NumericInput } from '../../../components/controls/numeric-input';
import { ProductHighlights } from '../../../components/products/highlights';
import { ProductTabs } from '../../../components/products/tabs';
import { ReviewsList } from '../../../components/reviews/list';
import { useAnalytics } from '../../../shared/analytics';
import { useAutomaticDiscountList } from '../../../shared/hooks/useAutomaticDiscountList';
import useLoggedInCustomer from '../../../shared/hooks/useLoggedInCustomer';
import { FaqList } from '../../../templates/faq/faqList';

export type GalleryItem = {
    originalData: IGatsbyImageData
    thumbnailData: IGatsbyImageData
    alt: string
    thumbnail: string
}

export type ProductInfoSharedPageProps = {
    product: Queries.ProductDetailPageQuery['product'],
    storeReviewRating: Queries.ProductDetailPageQuery['storeReviewRating'],
    reviewList: Queries.ProductDetailPageQuery['reviewList'],
    storeReviewCount: Queries.ProductDetailPageQuery['storeReviewCount'],
    shopifyAdmin: Queries.ProductDetailPageQuery['shopifyAdmin'],
    storefrontProduct: Queries.ProductDetailPageQuery['shopifyStorefront']['products']['nodes'][0],
    defaultVariant: Queries.ProductDetailPageQuery['product']['variants'][0] | null,
    location: Location
}

type Props = ProductInfoSharedPageProps & {
    allowUrlVariantDetection: boolean
}

export const ProductPage = ({ product, defaultVariant, storefrontProduct, location, allowUrlVariantDetection }: Props) => {
    // console.log('heree ProductDetailPage', data.product, serverData)

    // console.log('heree ProductDetailPage', data, pageContext)
    // const theme = useTheme();

    // const [reviewsEnabled, setReviewsEnabled] = useState(false)

    // const [isRequestingReview, setIsRequestingReview] = useState(false)

    const loggedInCustomer = useLoggedInCustomer();


    // console.log('hereee', {
    //   HorizontalSlantContainer,
    //   Grid,
    //   VariantSelector,
    //   ImageGallery,
    //   AddToCartMulti,
    //   AddToCart,
    //   MoneyDisplay,
    //   PurchaseCounter,
    //   NumericInput,
    //   ProductHighlights,
    //   ProductTabs,
    //   ReviewsList,
    //   FaqList,
    //   SeoHead,
    // })

    const headerSlantContainerNoContentStyles = headerSlantContainerNoContent();
    // const { isSiteFramed } = (serverData as any) || { isSiteFramed: false };
    const { isSiteFramed } = { isSiteFramed: false };


    const {
        title,
        media,
        productType,
        descriptionHtml
    } = product


    // const sortedMedia = useMemo(() => {
    //   if (indexOfFirstProductImage >= 0 && indexOfFirstProductImage < media.length) {
    //     // Remove the element from its current position
    //     const newMedia = [...media]
    //     const [element] = (newMedia as Array<any>).splice(indexOfFirstProductImage, 1);

    //     // Add the element to the beginning of the array
    //     (newMedia as Array<any>).unshift(element);

    //     return newMedia;
    //   }
    //   else {
    //     return media;
    //   }
    // }, [media])

    // console.log('hereeee')
    // console.log('heree ProductDetailPage', product, storefrontProduct)

    // const borderStyles = cardBorderStyles(theme);

    // const theme = useTheme();

    // const urlParams = new URLSearchParams(location.search);
    // console.log('heree location', uri, path, params, location)
    // console.log('serverData', serverData)
    const defaultQty = loggedInCustomer.wholesale ? 50 : 2;

    useEffect(() => {
        setQtyToAdd(loggedInCustomer.wholesale ? 50 : 2);
    }, [loggedInCustomer.wholesale])

    const [qtyToAdd, setQtyToAdd] = useState(defaultQty);
    const noVariant = product.hasOnlyDefaultVariant || !product.variants || product.variants.length === 0;
    // const urlVariantId = new URLSearchParams(location.search).get('variant');
    // const urlVariant = !noVariant ? product.variants.find(v => v.shopifyId.split('/').splice(-1)[0].toString() === urlVariantId) : null
    // const defaultVariantId = noVariant ? '' : (urlVariant ? urlVariant.shopifyId : last(product.variants).shopifyId)

    const [selectedVariantId, setSelectedVariantId] = React.useState<string>(noVariant ? null : defaultVariant.shopifyId);

    const discounts = useAutomaticDiscountList();
    const analytics = useAnalytics();

    useEffect(() => {
        if (allowUrlVariantDetection) {
            if (typeof window !== 'undefined' && !noVariant) {
                const urlVariantId = new URLSearchParams(location.search).get('variant');
                if (urlVariantId) {
                    const urlVariant = !noVariant ? product.variants.find(v => v.shopifyId.split('/').splice(-1)[0].toString() === urlVariantId) : null
                    if (urlVariant) {
                        setSelectedVariantId(urlVariant.shopifyId)
                    }
                }
            }
        }
    }, []);
    const shopifyIdNumberOnly = product.storefrontId.split('/').splice(-1)[0]

    useEffect(() => {
        if (location.search.indexOf('judgeme_review_source') > -1) {
            navigate('/review?' + location.search + '&pid=' + shopifyIdNumberOnly)
        }
    }, [])

    useEffect(() => {
        analytics.trackPageView(AnalyticsPageType.product, {
            collectionHandle: productType,
            products: [
                {
                    ...product
                }
            ]
        }, undefined, storefrontProduct?.metafields);
    }, [])

    // console.log('heree ProductDetailPage', product, shopifyIdNumberOnly)

    const selectedVariant = useMemo(() => {
        return selectedVariantId ? product.variants.find(v => v.shopifyId === selectedVariantId) : defaultVariant
    }, [selectedVariantId])

    const discountedPrice = discounts.discountPriceForPrice(1, selectedVariant.presentmentPrices[0].price, 1);

    // console.log('heree selectedVariant', selectedVariant, selectedVariantId, defaultVariantId)

    const images: GalleryItem[] = useMemo(() => {
        return media.map((node, index) => ({
            index,
            originalData: getImage((node as any).image.localFile.childImageSharp.original),
            thumbnailData: getImage((node as any).image.localFile.childImageSharp.thumbnail),
            thumbnail: getSrc((node as any).image.localFile.childImageSharp.thumbnail),
            alt: (node as any).image.altText,
        })).filter(img => img.originalData && img.thumbnailData) // Ensure we only include images with both original and thumbnail data
    }, [media])

    return (<>
        {!isSiteFramed && <HorizontalSlantContainer id={'product_' + product.shopifyId} autoHeight>
            <Container sx={headerSlantContainerNoContentStyles}></Container>
        </HorizontalSlantContainer>}
        <Container sx={{ pt: { xs: 2, sm: 2, md: 6 } }}>
            <Grid container rowSpacing={2} columnSpacing={4}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 6
                    }}>
                    {images.length > 0 && (
                        <div style={{ position: 'relative' }}>
                            <ImageGallery
                                renderItem={(item: any) => {
                                    return <GatsbyImage loading={item.index === 0 ? 'eager' : 'lazy'} image={item.originalData} alt={item.alt} />
                                }}
                                items={images as any}
                                thumbnailPosition="bottom"
                                showThumbnails={true}
                                showNav={true}
                                lazyLoad={true}
                                infinite={true}
                                showPlayButton={false}
                                showFullscreenButton={false}
                                renderThumbInner={(item: any) => {
                                    return (
                                        <GatsbyImage
                                            image={item.thumbnailData}
                                            alt={item.alt}
                                            loading="eager"
                                        />
                                    )
                                }}
                            />
                        </div>
                    )}
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 6
                    }}>
                    <Stack direction='column' gap={2}>
                        <Typography variant='h1'>{title}</Typography>

                        <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} gap={{ xs: 2, sm: 3, md: 8 }} alignItems={{ xs: 'flex-start', sm: 'flex-start', md: 'center' }}>
                            {selectedVariant.title !== 'Default Title' && <Typography component={'h2'} variant='h4'>{selectedVariant.title}</Typography>}
                            <MoneyDisplay money={discountedPrice} nonDiscounted={selectedVariant.presentmentPrices[0].price} direction='row' showSavePill />
                        </Stack>

                        <Box
                            dangerouslySetInnerHTML={{
                                __html: descriptionHtml,
                            }}
                        />
                    </Stack>

                    <Box mb={2}>
                        <ProductHighlights metafields={storefrontProduct.metafields} />
                    </Box>

                    <Stack direction='column' gap={2}>
                        {/* <Box p={2} sx={{ ...borderStyles }}> */}
                        <Box>
                            <Stack direction='column' gap={2}>
                                <AddToCartMulti product={product} variantId={selectedVariantId} quantityDescription='Bottle' selectedQuantity={qtyToAdd} setSelectedQuantity={setQtyToAdd} />
                                <Stack direction='row' gap={2} sx={{ width: '100%' }} alignItems={'center'} justifyContent={'center'}>
                                    <NumericInput
                                        id='product-quantity'
                                        aria-label='Select quantity'
                                        textBox={loggedInCustomer.wholesale}
                                        value={qtyToAdd || defaultQty}
                                        includeZero={false}
                                        variant="outlined"
                                        size="small"
                                        onChange={(v) => setQtyToAdd(v)}
                                    />
                                    {/* <Typography variant='body1' sx={{ width: '75px' }} component={'div'}>{(qtyToAdd ? qtyToAdd : defaultQty) === 1 ? 'bottle of' : 'bottles of'}</Typography>                   */}

                                    {!isSiteFramed && <VariantSelector fullWidth id={product.id} product={product} onVariantChange={setSelectedVariantId} selectedVariantId={selectedVariantId} />}
                                </Stack>

                                {!isSiteFramed && <AddToCart pathname={location.pathname} quantity={qtyToAdd || defaultQty} available={selectedVariant.inventoryQuantity > 0} variantId={selectedVariantId} product={product} pageType={AnalyticsPageType.product} />}

                                <PurchaseCounter value={140} autoIncrementPeriod='hour' />
                                {/* <MoneyDisplay money={selectedVariant.presentmentPrices[0].price} nonDiscounted={selectedVariant.presentmentPrices[0].compareAtPrice} direction='row' /> */}
                            </Stack>
                        </Box>
                        <ProductTabs metafields={storefrontProduct.metafields} />
                    </Stack>
                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12
                    }}>
                    <Box mt={3}>
                        <Paper elevation={0} className='judgeme-reviews-container'>
                            <Stack spacing={2} justifyContent={'center'} alignItems={'center'} pt={2}>
                                <ReviewsList list allowSort order='helpful' id={'product_' + product.shopifyId} />
                            </Stack>
                        </Paper>
                    </Box>

                </Grid>

                <Grid
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 12,
                        lg: 12
                    }}>
                    <Box mt={3}>
                        <Paper elevation={0}>
                            <Stack spacing={2} justifyContent={'center'} alignItems={'center'} pt={2}>
                                <Box>
                                    <Typography variant="h3" gutterBottom>
                                        Frequently Asked Questions
                                    </Typography>
                                </Box>

                                <FaqList />
                            </Stack>
                        </Paper>
                    </Box>
                </Grid>
            </Grid>
        </Container >
    </>);
}
